import { useEffect } from "react";

import { Button, TextArea } from "studio-design-system";

import { RateModalStars } from "~/components/BTSInProductVideoPage/Review/Modals/RateModal/RateModalStars";
import { reviewModalTitle } from "~/components/BTSInProductVideoPage/Review/ReviewFormOrchestrator/utils";

import * as styles from "../Modals.css";

export const RateModal = ({
  isLoading,
  lastClassVideo,
  handleContinue,
  productReviewScore,
  productReviewText,
  setProductReviewText,
  setProductReviewScore,
}: {
  isLoading?: boolean;
  lastClassVideo?: boolean;
  productReviewScore: number;
  productReviewText?: string;
  handleContinue: () => void;
  setProductReviewText?: (value: string) => void;
  setProductReviewScore: (value: number) => void;
}) => {
  //This code is responsible for the textarea to expand in height after minHeight of 135px is reached
  useEffect(() => {
    const ratingBox = document.getElementById("ratingTextBox");
    if (ratingBox) {
      ratingBox.style.height = "0px";
      const taHeight = ratingBox.scrollHeight < 135 ? 135 : ratingBox.scrollHeight + 2;
      if (taHeight > 250) {
        ratingBox.style.overflow = "auto";
        ratingBox.style.height = "250px";
      } else {
        ratingBox.style.overflow = "hidden";
        ratingBox.style.height = taHeight + "px";
      }
    }
  }, [productReviewText]);

  return (
    <div className={styles.container}>
      <h3 className={styles.modalTitle}>{reviewModalTitle(lastClassVideo)}</h3>
      <RateModalStars
        handleContinue={handleContinue}
        productReviewScore={productReviewScore}
        setProductReviewScore={setProductReviewScore}
      />
      {setProductReviewText && (
        <div className={styles.formContainer}>
          <TextArea
            id="ratingTextBox"
            spellCheck={false}
            value={String(productReviewText)}
            className={styles.textArea}
            onChange={(e) => setProductReviewText(e.target.value)}
            placeholder="Tell us a little about your own personal experience watching this class. Did you enjoy it?"
          />
          <Button className={styles.ctaButton} onClick={handleContinue} isLoading={isLoading}>
            Save and Continue
          </Button>
        </div>
      )}
    </div>
  );
};
